/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Rankings_Total_CountInputs */



/**
* | output |
* | --- |
* | "{count} player(s)" |
*
* @param {Rankings_Total_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_total_count = /** @type {((inputs: Rankings_Total_CountInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Total_CountInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} joueur(s)`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} jugador(es)`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} jogador(es)`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} giocatore/i`)
	return /** @type {LocalizedString} */ (`${i?.count} player(s)`)
});